import { OverlayTrigger, Tooltip } from "react-bootstrap";
import React from "react";
import PropTypes from "prop-types";

const triggers = ["focus", "hover", "click"];

BadgeWithTooltip.propTypes = {
  type: PropTypes.string.isRequired,
  tooltipTitle: PropTypes.string.isRequired,
  badgeLabel: PropTypes.string.isRequired,
};

export function BadgeWithTooltip({ type, tooltipTitle, badgeLabel }) {
  return (
    <OverlayTrigger
      trigger={triggers}
      placement="auto"
      delay={{ show: 10, hide: 150 }}
      overlay={<Tooltip style={{ position: "fixed" }}>{tooltipTitle}</Tooltip>}
    >
      <span tabIndex={1} className={`badge bg-${type}`}>
        {badgeLabel}
      </span>
    </OverlayTrigger>
  );
}
